(function () {
  const STORAGE_KEY = 'yarn-social:wishlist';

  function itemKey(item) {
    return (item.type === 'collection' ? 'collection' : 'product') + ':' + String(item.id || '');
  }

  function read() {
    try {
      const raw = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (!Array.isArray(raw)) return [];

      const seen = new Set();
      return raw
        .map((item) => (item && typeof item === 'object' ? item : { id: String(item) }))
        .filter((item) => {
          item.id = String(item.id || '');
          item.type = item.type === 'collection' ? 'collection' : 'product';
          const key = itemKey(item);
          if (!item.id || seen.has(key)) return false;
          seen.add(key);
          return true;
        });
    } catch (error) {
      return [];
    }
  }

  function store(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {}
  }

  function itemFromButton(button) {
    return {
      id: String(button.dataset.wishlistId || ''),
      type: button.dataset.wishlistType === 'collection' ? 'collection' : 'product',
      handle: button.dataset.wishlistHandle || '',
      url: button.dataset.wishlistUrl || '',
      title: button.dataset.wishlistTitle || '',
      image: button.dataset.wishlistImage || '',
      price: button.dataset.wishlistPrice || '',
      comparePrice: button.dataset.wishlistComparePrice || '',
      variantId: String(button.dataset.wishlistVariantId || ''),
      available: button.dataset.wishlistAvailable === 'true'
    };
  }

  function enrich(items) {
    let changed = false;
    document.querySelectorAll('[data-wishlist-id]').forEach((button) => {
      const fresh = itemFromButton(button);
      const index = items.findIndex((item) => itemKey(item) === itemKey(fresh));
      if (index === -1 || !fresh.url) return;
      const merged = Object.assign({}, items[index], fresh);
      if (JSON.stringify(merged) !== JSON.stringify(items[index])) {
        items[index] = merged;
        changed = true;
      }
    });
    if (changed) store(items);
    return items;
  }

  function syncButtons(items) {
    const keys = new Set(items.map(itemKey));
    document.querySelectorAll('[data-wishlist-id]').forEach((button) => {
      const active = keys.has(itemKey(itemFromButton(button)));
      const label = active ? button.dataset.wishlistRemoveLabel || '' : button.dataset.wishlistAddLabel || '';
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', label);
      const visibleLabel = button.querySelector('[data-wishlist-button-label]');
      if (visibleLabel && visibleLabel.textContent !== label) visibleLabel.textContent = label;
    });
  }

  function syncHeader(items) {
    const count = items.length;
    document.querySelectorAll('[data-wishlist-count]').forEach((badge) => {
      if (badge.textContent !== String(count)) badge.textContent = String(count);
      badge.hidden = count === 0;
    });
    document.querySelectorAll('[data-wishlist-link]').forEach((link) => {
      const label = count
        ? (link.dataset.wishlistCountLabel || '').replace('__count__', String(count))
        : link.dataset.wishlistLabel;
      if (label && link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
    });
  }

  function sync() {
    const items = enrich(read());
    syncButtons(items);
    syncHeader(items);
    return items;
  }

  function write(items) {
    store(items);
    sync();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items } }));
  }

  window.YarnSocialWishlist = { read, write, sync, itemKey };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-id]');
    if (!button) return;
    event.preventDefault();

    const items = enrich(read());
    const fresh = itemFromButton(button);
    const index = items.findIndex((item) => itemKey(item) === itemKey(fresh));
    if (index === -1) items.push(fresh);
    else items.splice(index, 1);
    write(items);
  });

  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('shopify:section:load', sync);
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) sync();
  });

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      sync();
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
